import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalSelector from "./ModalSelector";
import DataTable from "../Tables/DataTable";
import { useCommercials } from "../../hooks";
import { Typography, Box, TextField } from "@mui/material";
import { Iconify } from "../../utilities";
import LaeButton from "../Buttons/LaeButton";

const CommercialSelector = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { loading, data, fetchData } = useCommercials();
  const [search, setSearch] = useState("");

  const headers = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
    },
    {
      id: "nombre",
      numeric: false,
      disablePadding: false,
      label: t('common:form.firstName').toUpperCase(),
    },
    {
      id: "apellidos",
      numeric: false,
      disablePadding: false,
      label: t('common:form.lastName').toUpperCase(),
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('common:form.nif'),
    },
  ];

  const handleSelect = (row) => {
    onClose(row);
  };

  const handleFetchData = async ({ page, size }) => {
    try {
      await fetchData({ page, size, razonSocial: search });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ModalSelector
      open={open}
      onClose={onClose}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        p: 2,
        pt: 8,
        gap: 5,
        alignItems: "center",
      }}
    >
      <Box
        sx={{ position: "absolute", right: 10, top: 5 }}
        onClick={() => handleSelect()}
      >
        <Iconify icon="mdi:close" sx={{ height: 24, width: 24 }} />
      </Box>
      <Typography variant="h4">{t('common:commercials.select')}</Typography>
      <DataTable
        data={data?.rows}
        meta={data?.meta}
        isLoading={loading}
        headers={headers}
        onClickRow={handleSelect}
        fetcher={handleFetchData}
        currentPage={data?.current_page}
      >
        <Box
          m={2}
          display={"flex"}
          flexDirection={"row"}
          width={"100%"}
          gap={2}
        >
          <TextField
            id="razonSocial-input"
            label={t('aaff:fields.name')}
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            inputProps={{
              "aria-label": "controlled",
            }}
          />
          <LaeButton onClick={handleFetchData} sx={{ width: 100 }}>
            <Typography>{t('common:actions.search')}</Typography>
          </LaeButton>
        </Box>
      </DataTable>
    </ModalSelector>
  );
};

export default CommercialSelector;
